import * as React from 'react';
import type { SVGProps } from 'react';

const IconBriefcase = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 59" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.051.052c-3.055 0-5.734 2.27-5.734 5.258v3.701H7.428c-4.063 0-7.397 3.349-7.397 7.42v34.916c0 4.071 3.335 7.42 7.397 7.42H57.04c4.068 0 7.397-3.35 7.397-7.42V16.431c0-4.069-3.33-7.42-7.397-7.42H46.152v-3.7c0-2.986-2.675-5.26-5.735-5.26H24.051Zm0 2.927h16.367c1.643 0 2.807 1.14 2.807 2.33v3.702h-21.98V5.31c0-1.188 1.173-2.331 2.807-2.331Zm-16.623 8.96H57.04c2.466 0 4.47 2.012 4.47 4.492v4.652L32.234 32.228 2.957 21.083v-4.652c0-2.478 2.013-4.493 4.47-4.493h.001Zm-4.47 12.277 21.466 8.171a8.082 8.082 0 0 0-.195 1.773c0 4.404 3.602 8.006 8.005 8.006 4.41 0 8.013-3.602 8.013-8.006 0-.607-.067-1.202-.196-1.775l21.46-8.169v27.131c0 2.48-2.004 4.493-4.47 4.493H7.429c-2.457 0-4.47-2.015-4.47-4.493v-27.13l-.001-.001Zm34.313 9.227c.032.233.05.473.05.717a5.06 5.06 0 0 1-5.086 5.078 5.06 5.06 0 0 1-5.079-5.078c0-.243.018-.482.05-.715l4.508 1.716v.001c.335.127.706.127 1.041 0l4.515-1.719Z"
      fill="currentColor"
    />
  </svg>
);

export default IconBriefcase;
